<template>
      <div no-body class="lku-arset-unearn"> 
      <!-- <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row> -->
      <b-row class="ml-1 mr-1">
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Payment Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" size="sm"></b-form-input>
              <b-form-input v-model="tblData.tgl2" type="date" size="sm" class="ml-1"></b-form-input>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label>Payment No.</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="Payment Number" size="sm"></b-form-input>
                  </b-input-group>
                </b-col>
              <b-col  lg="6">
                  <b-input-group >
                    <b-form-input v-model="tblData.customer" placeholder="Customer" size="sm"></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>                      
        </b-col>
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Destination Bank</label></b-input-group-prepend>
                <b-form-input v-model="tblData.namabank" placeholder="Bank Name" size="sm"></b-form-input>
                <b-form-input v-model="tblData.reference" placeholder="Reference/Cheque/giro" class="ml-1" size="sm"></b-form-input>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="8">
                  <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.uraian" size="sm"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                   <div style="text-align:right;">
                    <b-button variant="success" size="sm" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear</b-button>
                   </div>
                </b-col>
            </b-row>                            
        </b-col>
      </b-row>
        <b-card no-body>
            <b-table
            class="mb-0"
            ref="tblArset"
            responsive
            striped hover small 
            style="font-size:smaller;" 
            :items="tblData.items"
            :fields="fields"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem" :busy="lkuLoading" show-empty
          >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #empty="scope">
            <h6 class="text-center">{{ scope.emptyText }}</h6>
          </template>
          <template #emptyfiltered="scope">
            <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
          </template>
          <template v-slot:cell(tglpaym)="data">
            {{ data.item.tglpaym | moment("DDMMMYYYY") }}
          </template>
            <template v-slot:cell(pbb_amt)="data">
              {{data.item.matauang}} {{data.item.pbb_amt | numFormat}}
            </template>
            <template v-slot:cell(pbb_ost)="data">
              {{data.item.pbb_ost | numFormat}}
            </template>
          </b-table>
          <b-row>
            <b-col cols="4">
              <div class="pt-2">
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
            </div>        
            </b-col>
            <b-col cols="3">            
                <b-row class="ml-2 mt-2">
                  <span class="pt-1 pr-2">Limit per page</span>
                  <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
                </b-row>
            </b-col>
            <b-col cols="5">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
        
    </div>
</template>
<style lang="scss">
.lku-arset-unearn {
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                font-size: smaller;
                width: 90px;
            }
        }
    }
}
</style>

<script>
import pinjmanpayment from "../../apis/pinjamanpayment";

export default {
  data() {
    return {
      fields: [
          {
            key: "paymno",
            label: "Payment No.",
            sortable: true
          },
          {
            key: "tglpaym",
            label: "Paym.Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          // {
          //   key: "namabank",
          //   label: "Destination Bank Acc.",
          // },
          {
            key: "pbb_amt",
            label: "Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "pbb_ost",
            label: "Un-Settled Balance",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'paymno',
        sortDesc: false,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        unearned:'1'
      },
      lkuLoading:false
    };
  },
  computed: {
    // filterCustomer() {
    //   return this.tblData.customer;
    // },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.refresh();
    },   
    // filterCustomer: function(newval) {
    //   this.refresh();
    // },    
  },  
  props: ["formdata","selectedrow"],
  created: async function() {
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        } 
        else {
          if (this.tblData.tgl1 || this.tblData.tgl2) {
              this.refresh();
          }

        }
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter(ctx) {
        this.tblData.reference= '';
        this.tblData.kodebank=  '';
        this.tblData.namabank=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.invoice=  '';
        this.tblData.tgl1='';
        this.tblData.tgl2='';

        this.refresh();
    },    
    refresh: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      this.tblData.items= await pinjmanpayment.list(this.tblData);
      this.lkuLoading = false;
      // this.$refs.tblArset.refresh();
    }
  }
};
</script>
